<script>
	import { onMount, onDestroy } from "svelte";
	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "sveltestrap";
	import client from "../../../../services/client";
	import {
		errorMessage,
		sizeSelect,
		totalPages,
		loadingSort,
		initPage,
		trigerBlackoutSearch,
		carDetail,
	} from "../../../../store/store";
	import BookingTable from "./BookingTable.svelte";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import FilterForm from "../../../../components/FilterForm/FilterSortIssue.svelte";

	let data = [];
	let vehicleId = window.location.pathname.split(
		"/car-management/details/"
	)[1];

	//Start Logic for filter feature
	// const query = queryString.parse(window.location.search);
	const params = new Proxy(new URLSearchParams(window.location.search), {
		get: (searchParams, prop) => searchParams.get(prop),
	});
	$: queryParams = `?CarPlateNo=${plateNumber}&page=1&size=20&SortCol=scheduledStart&HasIssues=false&SortDir=desc`;
	let searchParams = window.location.search.toString();
	let querySize = searchParams.includes("size");
	let queryPage = searchParams.includes("page");
	let queryStatus = searchParams.includes("carStatus");

	// const plateNumber = "APIAUTOMOBEXTBECONOMY";
	const plateNumber = $carDetail.plateNumber;

	//End Logic for filter feature

	//FETCH Vehicle LIST
	const fetchData = async () => {
		try {
			loadingSort.set(true);
			errorMessage.set("");
			const res = await client(`/v1/filter${queryParams}`, {
				method: "GET",
				version: "Booking",
			});
			data = res.data.data;
			data.totalCount = res.data.totalCount;
			totalPages.set(res.data.totalPage);
			if (res.data.data) {
				loadingSort.set(false);
			}
		} catch (err) {
			loadingSort.set(false);
			console.log(err.response);
			// errorMessage.set(err.response.data.errors[""]["0"]);
		}
	};

	let bookingStat = "";
	let sortDirection = "";
	let sortHasIssue = false;
	const handleSearchBooking = (status, sortDir, hasIssues) => {
		bookingStat = status;
		sortDirection = sortDir;
		sortHasIssue = hasIssues;
		queryParams = `?CarPlateNo=${plateNumber}&page=${$initPage}&size=20&SortCol=scheduledStart&status=${status}&sortDir=${sortDir}&HasIssues=${sortHasIssue}`;

		fetchData();
	};

	$: if ($trigerBlackoutSearch) {
		queryParams = `?CarPlateNo=${plateNumber}&Page=${$initPage}&size=20&SortCol=scheduledStart&status=${bookingStat}&sortDir=${sortDirection}&HasIssues=${sortHasIssue}`;
		fetchData();
	}

	const trigerSort = (params) => {
		queryParams = `?CarPlateNo=${plateNumber}&Page=${$initPage}&size=20&SortCol=${params.num}&status=${bookingStat}&sortDir=${params.desc}&HasIssues=${sortHasIssue}`;
		fetchData();
	};

	onMount(async () => {
		initPage.set(1);
		fetchData();
	});

	// $: $sizeSelect, trigerSelectFuerlCard();

	onDestroy(() => {
		initPage.set(1);
		errorMessage.set("");
		sizeSelect.set("20");
	});

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<Col>
		<ErrorMessageHandler message={err} />
		<!-- <Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Fuel Card Management" />
			</Col> -->
		<div class="d-flex flex-row">
			<Col xs={6}>
				<FilterForm {handleSearchBooking} bookingStatus />
			</Col>
		</div>
		<div />
	</Col>
</Row>
<Row class="my-2">
	<Col>
		<BookingTable {data} bookingStatus {trigerSort} />
	</Col>
</Row>
